import React from 'react';
import { MdFileDownload, MdOutlineFilePresent, MdArrowForward } from 'react-icons/md';
import { useFormContext } from '../../context/FormContext';
import { SignupLayout } from '../ui/SignupLayout';
import { formatDate } from '../util/formatters';

export function PolicySecured({ history }) {
    const { formData, resetForm } = useFormContext();

    const handleViewDashboard = () => {
        // Reset the signup form data now that the policy is issued
        // The policy number is stored in context and will be available on the dashboard
        history.push('/dashboard');
    };

    return (
        <SignupLayout showProgress={false}>
            {/* -- Large check icon -- */}
            <div style={{ textAlign: 'center', padding: 'var(--space-xl) 0 var(--space-lg)' }}>
                <div className="policy-secured__check">
                    <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M4 12L9 17L20 6"
                            stroke="var(--brand-primary)"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </div>

            {/* -- Heading -- */}
            <h1 className="signup-heading" style={{ textAlign: 'center', marginTop: 0 }}>
                Policy coverage secured!
            </h1>
            <p className="signup-section__desc" style={{ textAlign: 'center' }}>
                Your hurricane coverage is now active. We've sent your policy documents to your email.
            </p>

            {/* -- Policy number + effective date card -- */}
            <div className="summary-card" style={{ marginBottom: 'var(--space-xl)' }}>
                <div className="summary-grid">
                    <div className="summary-row" style={{ marginBottom: 0 }}>
                        <span className="summary-row__label">Policy number</span>
                        <span className="summary-row__value">
                            {formData.PolicyNumber || '-'}
                        </span>
                    </div>
                    <div className="summary-row" style={{ marginBottom: 0 }}>
                        <span className="summary-row__label">Effective date</span>
                        <span className="summary-row__value">
                            {formatDate(formData.EffectiveDate)}
                        </span>
                    </div>
                </div>
            </div>

            {/* -- View dashboard CTA -- */}
            <button
                className="btn signup-cta"
                onClick={handleViewDashboard}
                style={{ marginBottom: 'var(--space-sm)' }}
            >
                View your dashboard <MdArrowForward />
            </button>

            {/* -- Download policy documents (stub) -- */}
            {/* TODO: Wire up to backend endpoint that returns policy documents
                once issuePolicy response includes document URLs or after
                generateDocument endpoint is integrated. */}

            {/* <button
                className="btn btn--outline signup-cta policy-secured__download-btn"
                disabled
                style={{ opacity: 0.5, cursor: 'not-allowed' }}
            >
                <MdFileDownload size={18} />
                Download policy documents
            </button> */}
        </SignupLayout>
    );
}